// ui/InteractionMode.tsx
import { createContext, useContext } from 'react';

export type InteractionMode = 'BUILD' | 'FILL' | 'VIEW';

const Ctx = createContext<InteractionMode>('VIEW');
export const InteractionModeProvider = Ctx.Provider;
export const useInteractionMode = () => useContext(Ctx);
